import { StandardEvents } from '@shopify/events';
let hideTimer;
document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  try {
    const { detail } = await event.promise;
    if (detail?.didError) return;
    const cartLink = document.querySelector('.hx-cart');
    if (!cartLink) return;
    const response = await fetch(`${cartLink.getAttribute('href')}.js`, {headers: {Accept: 'application/json'}});
    if (!response.ok) return;
    const cart = await response.json();
    const count = cartLink.querySelector('span');
    if (count) count.textContent = String(cart.item_count);
    if (detail?.source === 'product-form-component') {
      const feedback = document.querySelector('[data-hx-cart-feedback]');
      if (feedback) {
        feedback.hidden = false;
        clearTimeout(hideTimer);
        feedback.querySelector('button').onclick = () => {feedback.hidden = true;};
        hideTimer = setTimeout(() => {feedback.hidden = true;}, 8000);
      }
    }
  } catch (error) { /* Existing cart errors remain handled by the product form. */ }
});
